import { TaskQueue } from '@prismamedia/one-components';

export const ImagesTaskQueue = new TaskQueue('Téléchargement Images', {
  maxConcurency: 1,
  delay: 500,
});
